import { createStore, combineReducers } from 'redux';

import DocumentReducer from '../containers/document/store/reducer';
import DocumentTypeReducer from '../containers/document-type/store/reducer';
import ProviderReducer from '../containers/provider/store/reducer';
import AuthorizationReducer from './reducer/authentication';

const rootReducer = combineReducers({
  Document: DocumentReducer,
  DocumentType: DocumentTypeReducer,
  Authorization: AuthorizationReducer,
  Provider: ProviderReducer,
});

const store = createStore(rootReducer);

export type AppState = ReturnType<typeof rootReducer>

export default store;